import state from "./modulePondState.js";
import mutations from "./modulePondMutations.js";
import actions from "./modulePondActions.js";
import getters from "./modulePondGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
